import { Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { useContext, useEffect, useState } from 'react';
import '../../App.css';
import { StyleConstants, Styles } from '../../Styles';
import RestfulManager, { RES_STATUS_OK } from '../../manager/RestfulManager';
import SnackbarContext from '../../components/SnackbarContext';
import BoltIcon from '@mui/icons-material/Bolt';
import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import SessionManager from '../../manager/SessionManager';

const barChartStyle = {
    "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel":{
        fill: StyleConstants.fontColor,
    },
    "& .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel":{
        fill: StyleConstants.fontColor,
    },
    "& .MuiChartsAxis-left .MuiChartsAxis-line":{
        stroke: StyleConstants.fontColor,
    },
    "& .MuiChartsAxis-bottom .MuiChartsAxis-line":{
        stroke: StyleConstants.fontColor,
    },
    "& .MuiChartsAxis-left .MuiChartsAxis-tick":{
        stroke: StyleConstants.fontColor,
    },
    "& .MuiChartsAxis-bottom .MuiChartsAxis-tick":{
        stroke: StyleConstants.fontColor,
    },
    "& .MuiChartsGrid-line":{
        stroke: StyleConstants.fontColor,
        strokeWidth: "0.5",
    },
    "& .MuiChartsAxis-label tspan":{
        fill: StyleConstants.fontColor,
    },
    "& .MuiChartsLegend-series tspan":{
        fill: StyleConstants.fontColor,
    },
    "& .MuiChartsAxis-directionY .MuiChartsAxis-tickLabel": {
        transform: "translateX(3px) !important",
    },
    "& .MuiChartsAxis-directionY .MuiChartsAxis-label": {
        transform: "translateX(-10px) !important",
        marginLeft: '500px',
    },
};

const CarSettingsPage = () => {
    const { setOpenSnackBar, setSnackbarSeverity, setSnackbarMessage } = useContext(SnackbarContext);
    
    const sessionManager = new SessionManager();
    const restfulManager = new RestfulManager();

    const [cars, setCars] = useState([]);
    const [car, setCar] = useState({});

    const [devices, setDevices] = useState([]);
    const [availDevices, setAvailDevices] = useState([]);

    const [serialNum, setSerialNum] = useState('');

    const [deviceId, setDeviceId] = useState('');
    const [vvvf1Powering, setVvvf1Powering] = useState('');
    const [vvvf1Braking, setVvvf1Braking] = useState('');
    const [vvvf2Powering, setVvvf2Powering] = useState('');
    const [vvvf2Braking, setVvvf2Braking] = useState('');
    const [sivPowering, setSivPowering] = useState('');

    const [energyConsumptions, setEnergyConsumptions] = useState([]);
    const [energyConsumptionsMinValue, setEnergyConsumptionsMinValue] = useState(0);
    const [energyConsumptionsMaxValue, setEnergyConsumptionsMaxValue] = useState(0);

    const [refresh, setRefresh] = useState(0);

    const carSelectChange = (event) => {
        const selectedCar = event.target.value;
        setCar(selectedCar);
    };

    const deviceSelectChange = (event) => {
        const selectedDeviceId = event.target.value;
        setDeviceId(selectedDeviceId);

        const currentSerialNum = getSerialNum(selectedDeviceId);
        setSerialNum(currentSerialNum);
    };

    const updateCarDevice = () => {
        (async () => {
            const payload = {
                carCode: car.carCode,
                deviceId: deviceId !== ''? deviceId : null
            };

            const res = await restfulManager.updateCarDeviceId(sessionManager.getAccessToken(), payload);
            const json = await res.json();
            if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                setRefresh(refresh + 1);

                setSnackbarSeverity('success');
                setSnackbarMessage('The device has been assigned to the car.');
                setOpenSnackBar(true);
            } else {
                if (json && json.msg) {
                    setSnackbarSeverity('error');
                    setSnackbarMessage(json.msg);
                    setOpenSnackBar(true);
                }
            }
        })();
    };

    const updateEnergyConsumptionPara = () => {
        (async () => {
            car.vvvf1Powering = vvvf1Powering;
            car.vvvf1Braking = vvvf1Braking;
            car.vvvf2Powering = vvvf2Powering;
            car.vvvf2Braking = vvvf2Braking;
            car.sivPowering = sivPowering;

            const res = await restfulManager.updateCarPowering(sessionManager.getAccessToken(), car);
            const json = await res.json();
            if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                setRefresh(refresh + 1);
                setSnackbarSeverity('success');
                setSnackbarMessage('The energy consumption parameters has been updated.');
                setOpenSnackBar(true);
            } else {
                if (json && json.msg) {
                    setSnackbarSeverity('error');
                    setSnackbarMessage(json.msg);
                    setOpenSnackBar(true);
                }
            }
        })();
    };

    const getSerialNum = (selectedDeviceId) => {
        let currentSerialNum = '';

        const carDevice = devices.filter((currentDevice) => currentDevice.deviceId === selectedDeviceId);
        if (carDevice.length > 0) {
            currentSerialNum = carDevice[0].serialNum;
        }

        return currentSerialNum;
    };

    useEffect(() => {
        (async () => {
            let res = await restfulManager.getAvailableDevices(sessionManager.getAccessToken());
            let json = await res.json();
            if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                setAvailDevices(json.devices);
            }

            res = await restfulManager.getDevices(sessionManager.getAccessToken());
            json = await res.json();
            if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                setDevices(json.devices);
            }

            res = await restfulManager.getCars(sessionManager.getAccessToken());
            json = await res.json();
            if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                setCars(json.cars);

                if ((JSON.stringify(car) === '{}') && json.cars && (json.cars.length > 0)) {
                    setCar(json.cars[0]);
                } else {
                    const newSelectedCar = json.cars.filter((currentCar) => currentCar.carCode === car.carCode);
                    if (newSelectedCar.length > 0) {
                        setCar(newSelectedCar[0]);
                    }
                }
            }

            res = await restfulManager.getEnergyConsumptions(sessionManager.getAccessToken());
            json = await res.json();
            if ((res.status === 200) && (json.status === RES_STATUS_OK)) {
                setEnergyConsumptions(json.energyConsumptions);

                let minValue = Number.MAX_SAFE_INTEGER;
                let maxValue = 0;
                for (let i = 0; i < json.energyConsumptions.length; i += 1) {
                    const currentEnergyConsumed = json.energyConsumptions[i].energyConsumed;

                    if (currentEnergyConsumed < minValue) {
                        minValue = currentEnergyConsumed;
                    }

                    if (currentEnergyConsumed > maxValue) {
                        maxValue = currentEnergyConsumed;
                    }
                }
                setEnergyConsumptionsMinValue(minValue);
                setEnergyConsumptionsMaxValue(maxValue);
            }
        })();
    }, [refresh]);

    useEffect(() => {
        if (car) {
            if ((car.deviceId !== null) && (car.deviceId !== undefined)) {
                setDeviceId(car.deviceId);

                const currentSerialNum = getSerialNum(car.deviceId);
                setSerialNum(currentSerialNum);
            } else {
                setDeviceId('');

                setSerialNum('');
            }
            
            setVvvf1Powering(car.vvvf1Powering);
            setVvvf1Braking(car.vvvf1Braking);
            setVvvf2Powering(car.vvvf2Powering);
            setVvvf2Braking(car.vvvf2Braking);
            setSivPowering(car.sivPowering);
        }
    }, [car]);

    return (
        <>
            <Box sx={{ flexGrow: 1, padding: '8px' }}>
                <Stack direction="column" sx={{ width: '1840px' }}>
                    <Stack direction="row" alignItems="start" gap={2} justifyContent='space-evenly'>
                        <Stack direction="row" sx={{ alignItems: 'center' }}>
                            <Typography sx={{ color: StyleConstants.fontColor, fontSize: Styles.contentFont3, marginRight: '8px' }}>
                                Car Number:
                            </Typography>
                            <Select
                                value={cars.length > 0 && car ? car : ''}
                                onChange={carSelectChange}
                                sx={Styles.carSelect}
                                MenuProps={{
                                    sx: {
                                        "& .MuiMenuItem-root.Mui-selected": {
                                            color: 'red',
                                            backgroundColor: StyleConstants.mainBgColor,
                                        },
                                        "& .MuiMenuItem-root:hover": {
                                            backgroundColor: StyleConstants.highlightBgColor,
                                        },
                                        "& .MuiMenuItem-root.Mui-selected:hover": {
                                            backgroundColor: StyleConstants.highlightBgColor,
                                        },
                                    }
                                }}
                            >
                                {cars.map((car) => (
                                    <MenuItem
                                        key={car.carCode}
                                        value={car}
                                        sx={Styles.carSelect}
                                    >
                                        <Typography sx={{ fontSize: Styles.contentFont4 }}>
                                            {car.carCode}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </Stack>

                        <Stack direction="column">
                            <Stack direction="row" sx={{ alignItems: 'center' }}>
                                <Typography sx={{ color: StyleConstants.fontColor, fontSize: Styles.contentFont3, marginRight: '8px' }}>
                                    Device:
                                </Typography>
                                <Select
                                    value={availDevices && deviceId ? deviceId : ''}
                                    onChange={deviceSelectChange}
                                    sx={Styles.deviceSelect}
                                    MenuProps={{
                                        sx: {
                                            "& .MuiMenuItem-root.Mui-selected": {
                                                color: 'red',
                                                backgroundColor: StyleConstants.mainBgColor,
                                            },
                                            "& .MuiMenuItem-root:hover": {
                                                backgroundColor: StyleConstants.highlightBgColor,
                                            },
                                            "& .MuiMenuItem-root.Mui-selected:hover": {
                                                backgroundColor: StyleConstants.highlightBgColor,
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem
                                        key={'UNINSTALLED'}
                                        value={''}
                                        sx={Styles.deviceSelect}
                                    >
                                        <Typography sx={{ fontSize: Styles.contentFont4 }}>
                                        </Typography>
                                    </MenuItem>
                                    {deviceId && (
                                        <MenuItem
                                            key={deviceId}
                                            value={deviceId}
                                            sx={Styles.deviceSelect}
                                        >
                                            <Typography sx={{ fontSize: Styles.contentFont4 }}>
                                                {serialNum}
                                            </Typography>
                                        </MenuItem>
                                    )}
                                    {availDevices.map((currentDevice) => (
                                        <MenuItem
                                            key={currentDevice.deviceId}
                                            value={currentDevice.deviceId}
                                            sx={Styles.deviceSelect}
                                        >
                                            <Typography sx={{ fontSize: Styles.contentFont4 }}>
                                                {currentDevice.serialNum}
                                            </Typography>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Stack>

                            <Button
                                onClick={() => {
                                    updateCarDevice();
                                }}
                                sx={{ marginTop: '8px', width: '500px' }}
                            >
                                <Typography sx={{ color: StyleConstants.fontColor, fontSize: Styles.contentFont3 }}>
                                    Update Installed Device
                                </Typography>
                            </Button>
                        </Stack>

                        <Stack direction="column">
                            <Stack direction="row" sx={{ alignItems: 'center' }}>
                                <Typography sx={{ width: '350px', color: StyleConstants.fontColor, fontSize: Styles.contentFont3, marginRight: '8px' }}>
                                    VVVF1 Powering (kWh):
                                </Typography>
                                <TextField
                                    variant='outlined'
                                    size='small'
                                    sx={{
                                        width: '180px',
                                        border: '1px solid ' + StyleConstants.borderColor,
                                    }}
                                    inputProps={{
                                        maxLength: 20,
                                        style: {
                                            color: StyleConstants.borderColor,
                                            fontSize: '26px',
                                            textAlign: 'right',
                                        }
                                    }}
                                    value={vvvf1Powering}
                                    onChange={e => {
                                        setVvvf1Powering(e.target.value);
                                    }}
                                />
                            </Stack>

                            <Stack direction="row" sx={{ alignItems: 'center', marginTop: '8px' }}>
                                <Typography sx={{ width: '350px', color: StyleConstants.fontColor, fontSize: Styles.contentFont3, marginRight: '8px' }}>
                                    VVVF1 Braking (kWh):
                                </Typography>
                                <TextField
                                    variant='outlined'
                                    size='small'
                                    sx={{
                                        width: '180px',
                                        border: '1px solid ' + StyleConstants.borderColor,
                                    }}
                                    inputProps={{
                                        maxLength: 20,
                                        style: {
                                            color: StyleConstants.borderColor,
                                            fontSize: '26px',
                                            textAlign: 'right',
                                        }
                                    }}
                                    value={vvvf1Braking}
                                    onChange={e => {
                                        setVvvf1Braking(e.target.value);
                                    }}
                                />
                            </Stack>

                            <Stack direction="row" sx={{ alignItems: 'center', marginTop: '8px' }}>
                                <Typography sx={{ width: '350px', color: StyleConstants.fontColor, fontSize: Styles.contentFont3, marginRight: '8px' }}>
                                    VVVF2 Powering (kWh):
                                </Typography>
                                <TextField
                                    variant='outlined'
                                    size='small'
                                    sx={{
                                        width: '180px',
                                        border: '1px solid ' + StyleConstants.borderColor,
                                    }}
                                    inputProps={{
                                        maxLength: 20,
                                        style: {
                                            color: StyleConstants.borderColor,
                                            fontSize: '26px',
                                            textAlign: 'right',
                                        }
                                    }}
                                    value={vvvf2Powering}
                                    onChange={e => {
                                        setVvvf2Powering(e.target.value);
                                    }}
                                />
                            </Stack>

                            <Stack direction="row" sx={{ alignItems: 'center', marginTop: '8px' }}>
                                <Typography sx={{ width: '350px', color: StyleConstants.fontColor, fontSize: Styles.contentFont3, marginRight: '8px' }}>
                                    VVVF2 Braking (kWh):
                                </Typography>
                                <TextField
                                    variant='outlined'
                                    size='small'
                                    sx={{
                                        width: '180px',
                                        border: '1px solid ' + StyleConstants.borderColor,
                                    }}
                                    inputProps={{
                                        maxLength: 20,
                                        style: {
                                            color: StyleConstants.borderColor,
                                            fontSize: '26px',
                                            textAlign: 'right',
                                        }
                                    }}
                                    value={vvvf2Braking}
                                    onChange={e => {
                                        setVvvf2Braking(e.target.value);
                                    }}
                                />
                            </Stack>

                            <Stack direction="row" sx={{ alignItems: 'center', marginTop: '8px' }}>
                                <Typography sx={{ width: '350px', color: StyleConstants.fontColor, fontSize: Styles.contentFont3, marginRight: '8px' }}>
                                    SIV Powering (kWh):
                                </Typography>
                                <TextField
                                    variant='outlined'
                                    size='small'
                                    sx={{
                                        width: '180px',
                                        border: '1px solid ' + StyleConstants.borderColor,
                                    }}
                                    inputProps={{
                                        maxLength: 20,
                                        style: {
                                            color: StyleConstants.borderColor,
                                            fontSize: '26px',
                                            textAlign: 'right',
                                        }
                                    }}
                                    value={sivPowering}
                                    onChange={e => {
                                        setSivPowering(e.target.value);
                                    }}
                                />
                            </Stack>

                            <Button
                                onClick={() => {
                                    updateEnergyConsumptionPara();
                                }}
                                sx={{ marginTop: '8px', width: '500px' }}
                            >
                                <Typography sx={{ color: StyleConstants.fontColor, fontSize: Styles.contentFont3 }}>
                                    Update Energy Consumption Parameters
                                </Typography>
                            </Button>
                        </Stack>

                        <BoltIcon style={{ ...Styles.bigIcon }} />
                    </Stack>
                </Stack>

                <Stack direction="column" sx={{ width: '100%', marginTop: '16px', justifyContent: 'start' }}>
                    <Typography sx={{ fontSize: Styles.contentFont4, marginRight: '8px' }}>
                        Energy Consumption Statistics
                    </Typography>
                    <Stack direction="column" sx={{ alignItems: 'end' }}>
                        <Typography sx={{ width: '100%', fontSize: Styles.contentFont3, textAlign: 'center' }}>
                            Total Energy Consumption
                        </Typography>
                        <BarChart
                            dataset={energyConsumptions}
                            yAxis={[
                                {
                                    min: energyConsumptionsMinValue,
                                    max: energyConsumptionsMaxValue,
                                }
                            ]}
                            xAxis={[
                                {
                                    scaleType: 'band',
                                    dataKey: 'carCode',
                                    label: 'Car No.',
                                }
                            ]}
                            series={[
                                {
                                    dataKey: 'energyConsumed',
                                    label: 'Total Energy Consumption',
                                }
                            ]}
                            grid={{ horizontal: true }}
                            width={1800}
                            height={460}
                            sx={{
                                ...barChartStyle,
                                [`.${axisClasses.left} .${axisClasses.label}`]: {
                                    transform: 'translate(-20px, 0)',
                                },
                            }}
                        />
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};

export default CarSettingsPage;